import { Routes } from '@angular/router';

import { getPortalType, Portals } from '../services/web-config/web-config.helper';

export function loadPortalRoutes(): Promise<Routes> {
  const portalId = getPortalType();

  switch (portalId) {
    case Portals.Merchant:
      return import('src/app/portals/merchant/merchant.routes').then((m) => m.merchantRoutes);

    case Portals.Support:
      return import('src/app/portals/support/support.routes').then((m) => m.supportRoutes);

    case Portals.Integrator:
    case Portals.Developer:
      return import('src/app/portals/developer/developer.routes').then((m) => m.developerRoutes);

    default:
      console.warn(`No routes defined for portalId: ${portalId}`);
      return Promise.resolve([]);
  }
}
